import Router from './router' 

const APP_NAME = '西岛直读远传抄表管理系统';
const APP_VERSION='2.1版';
const COPYRIGHT = 'copyright 2021 河南西岛仪表研发有限公司';
const PAGE_SIZE = 20;
const NO_MORE_DATA = '没有更多数据了';
const SUBMITING = '正在提交...';
const ACTION_PWD = 'xdkj123987';
const PREPAY_SIAN_PWD = '860000';

function saveUseLocal(userInfo) {
	removeUserInfo();
	window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
}
function getUserLocal() {
	let userInfo = window.sessionStorage.getItem("userInfo");
	return JSON.parse(userInfo);
}
function removeUserInfo(){
  window.sessionStorage.removeItem("userInfo");
}
function goHome(){
	let userInfo = getUserLocal();
	if(userInfo == null){
		Router.replace("/");
	}else{
		Router.replace("/main");
	}
}
function getRandomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}
function getObjectType(obj) {
	var result;
	var str = Object.prototype.toString.call(obj);
	switch (str) {
		case '[object Object]':
			result = 'Object';
			break;
		case '[object Array]':
			result = 'Array';
			break;
		case '[object String]':
			result = 'String';
			break;
		case '[object Boolean]':
			result = 'Boolean';
			break;
		case '[object Number]':
			result = 'Number';
			break;
		case '[object FormData]':
			result = 'FormData';
			break;
		default:
			result = 'Object';
			break;
	}
	return result;
}

function deepClone(data) {
	var type = getObjectType(data);
	var obj;
	if (type === 'Array') {
		obj = [];
	} else if (type === 'Object') {
		obj = {};
	} else {
		return data; //不再具有下一层次
	}
	if (type === 'Array') {
		for (var i = 0, len = data.length; i < len; i++) {
			obj.push(deepClone(data[i]));
		}
	} else if (type === 'Object') {
		for (var key in data) {
			obj[key] = deepClone(data[key]);
		}
	}
	return obj;
}
function easyDeepClone(data) {
	return JSON.parse(JSON.stringify(data));
}
function formatDateShortly(date) {
	var myyear = date.getFullYear();
	var mymonth = date.getMonth() + 1;
	var myweekday = date.getDate();

	if (mymonth < 10) {
		mymonth = "0" + mymonth;
	}
	if (myweekday < 10) {
		myweekday = "0" + myweekday;
	}
	return (myyear + "-" + mymonth + "-" + myweekday);
}
function formatDate(date) {
	var myyear = date.getFullYear();
	var mymonth = date.getMonth() + 1;
	var myweekday = date.getDate();
	var myHour = date.getHours	();
	var myMinute = date.getMinutes();
	var mySecond = date.getSeconds();

	if (mymonth < 10) {
		mymonth = "0" + mymonth;
	}
	if (myweekday < 10) {
		myweekday = "0" + myweekday;
	}
	if(myHour<10){
		myHour = "0" + myHour;
	}
	if(myMinute<10){
		myMinute = "0" + myMinute;
	}
	if(mySecond<10){
		mySecond = "0" + mySecond;
	}
	return (myyear + "-" + mymonth + "-" + myweekday+" "+myHour+":"+myMinute+":"+mySecond);
}
function getReadMeterTaskTypeList(){
		return [
			{
				value:"0",
				name:'重启集中器'
			},
			{
				value:"1",
				name:'下发地址'
			},
			{
				value:"2",
				name:"单抄表"
			},
			{
				value:"3",
				name:'抄采集器'
			},
			{
				value:"4",
				name:"抄小区"
			},
			{
				value:"5",
				name:'抄全部小区'
			},
			{
				value:"6",
				name:'抄选中表'
			},
		];
}
function getMeterStateList(){
	return [
		{
			value:0,
			name:'异常'
		},
		{
			value:1,
			name:'正常'
		},
		{
			value:2,
			name:'数据错误'
		},
		{
			value:3,
			name:'线路故障'
		},
		{
			value:4,
			name:'超时'
		},
		{
			value:5,
			name:'人工修改'
		},
		{
			value:6,
			name:'异常'
		},
	];
}
function getOpenList(){
	return [
		{
			value:1,
			name:'开'
		},
		{
			value:0,
			name:'关'
		},
	];
}
function getPayTypeList(){
	return [
		{
			value:2,
			name:'招商银行'
		},
		{
			value:1,
			name:'支付宝'
		},
		{
			value:0,
			name:'营业厅'
		},
	];
}
function getDeductionStyleList(){
	return [
		{
			value:1,
			name:'抄表后结算'
		},
		{
			value:0,
			name:'抄表后不结算'
		},
	];
}
function getPrepaySignList(){
	return [
		{
			value:1,
			name:'预'
		},
		{
			value:0,
			name:'后'
		},
	];
}
function getLiHUList(){
	return [
		{
			value:'0',
			name:'非立户表'
		},
		{
			value:'1',
			name:'立户表'
		},
	];
}
function getSupplyModeList(){
	return [
		{
			value:1,
			name:'一次供水'
		},
		{
			value:2,
			name:'二次供水'
		},
	];
}
function getSolidList(){
	return [
		{
			value:0,
			name:'虚表'
		},
		{
			value:1,
			name:'实表'
		},
	];
}
function getHasList(){
	return [
		{
			value:1,
			name:'有'
		},
		{
			value:0,
			name:'无'
		},
	];
}
function getMainMeterList(){
	return [
		{
			value:0,
			name:'普通表'
		},
		{
			value:1,
			name:'小区总表'
		},
		{
			value:2,
			name:'楼总表'
		},
	];
}
function getValueByNameFromList(name,list){
	var result = '';
	for(let i=0;i<list.length;i++){
		let obj = list[i];
		if(obj.value==name){
			result = obj.name;
			break;
		}
	}
	return result;
}
function getHouseKindList(){
	return [
		{
			value:1,
			name:'多层'
		},
		{
			value:2,
			name:'高层'
		},
		{
			value:3,
			name:'商业'
		},
		{
			value:4,
			name:'企业'
		},
	];
}
function getNeighborTypeList(){
	return [
		{
			value:12,
			name:'NB表',
		},
		{
			value:13,
			name:'无线LoRa表',
		},
		{
			value:0,
			name:'其他表',
		},
	]
}
function getWarnStyleList(){
	return [
		{
			value:1,
			name:'短信'
		},
		{
			value:2,
			name:'邮件'
		},
	]
}
function getProtocolList(){
	return [
		{
			value:0,
			name:'标准协议',
		},
		{
			value:1,
			name:'自主协议',
		},
		{
			value:2,
			name:'188协议',
		},
		{
			value:3,
			name:'自主协议2',
		},
		{
			value:4,
			name:'D10',
		},
		{
			value:5,
			name:'聚合协议MBUS',
		},
		{
			value:6,
			name:'聚合协议485',
		},
		{
			value:7,
			name:'NB协议',
		},
		{
			value:8,
			name:'无线LoRa协议',
		},
		{
			value:9,
			name:'162协议',
		}
	]
}
function getGprsProtocol(protocol){
		var result = '';
		let list = this.getProtocolList();
		for(let i=0;i<list.length;i++){
			let obj = list[i];
			if(obj.value==protocol){
				result = obj.name;
				break;
			}
		}
		return result;
}
function getReadMeterType(readObj){
	let otype = getObjectType(readObj);
	if(otype == 'String'){
		readObj = parseInt(readObj);
	}
	let result = null;
	switch(readObj){
		case 1:
			result = '抄小区';
		break;
		case 2:
			result = '抄全部小区';
		break;
		case 3:
			result = '单抄表';
		break;
		case 4:
			result = '抄集中器';
		break;
		default:
			result = '未知抄表类型';
			break;
	}
	return result;
}
//以下两个方法用于本地分页
function getListStart(pageIndex,pageSize){
	return (pageIndex-1)*pageSize;
}
function getListEnd(pageIndex,pageSize){
	return pageIndex*pageSize;
}
export default {
	APP_NAME,
	APP_VERSION,
	COPYRIGHT,
	NO_MORE_DATA,
	SUBMITING,
	PAGE_SIZE,
	ACTION_PWD,
	PREPAY_SIAN_PWD,
	saveUseLocal,
	getUserLocal,
	removeUserInfo,
	goHome,
	getRandomInt,
	getObjectType,
	deepClone,
	easyDeepClone,
	formatDate,
	getListStart,
	getListEnd,
	getProtocolList,
	getGprsProtocol,
	getReadMeterType,
	getNeighborTypeList,
	getHouseKindList,
	getMainMeterList,
	getSupplyModeList,
	getSolidList,
	getLiHUList,
	getHasList,
	getOpenList,
	getDeductionStyleList,
	getPrepaySignList,
	getWarnStyleList,
	getMeterStateList,
	getValueByNameFromList,
	getReadMeterTaskTypeList,
	getPayTypeList,
	formatDateShortly,
}
